import './NotificationsStatusFilter.scss';

const NotificationsStatusFilter = ({
	setNoticationStatus,
	currentStatus
}) => {
	//TODO set the status key words directly with the backend
	const handleNotificationStateChange = (status) => {
		setNoticationStatus(status);
	};
	return (
		<div className='notificationsStatus-container'>
			<a
				className={`notifications-status ${
					currentStatus === 'all' ? 'active' : ''
				}`}
				onClick={() => handleNotificationStateChange('all')}
			>
				All
			</a>
			<a
				className={`notifications-status ${
					currentStatus === 'notRead' ? 'active' : ''
				}`}
				onClick={() =>
					handleNotificationStateChange('notRead')
				}
			>
				Not read
			</a>
			<a
				className={`notifications-status ${
					currentStatus === 'read' ? 'active' : ''
				}`}
				onClick={() =>
					handleNotificationStateChange('read')
				}
			>
				Read
			</a>
		</div>
	);
};

export default NotificationsStatusFilter;
